import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import "../../uiControls/commonStyles.css";
import * as utils from "../../common/utils";

const thBackgoundColor = "#3a8ddd";
const thFontColor = "white";
const thFontWeight = "bold";

export const TableForMissingDates = (props) => {
  const { pagging, columns, data, selectedRows, setSelectedRows } = props;

  const paperStyles = !pagging
    ? { width: "100%", height: "calc(100vh - 390px)" }
    : { width: "100%", overflow: "hidden" };
  const tableHeight = !pagging
    ? { height: "calc(100vh - 390px)" }
    : { overflow: "hidden" };

  const handleRowSelect = (row) => {
    if (isRowSelected(row[columns[0]["keyField"]])) {
      setSelectedRows(
        selectedRows.filter(
          (selectedRow) =>
            selectedRow[columns[0]["keyField"]] !== row[columns[0]["keyField"]]
        )
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const isRowSelected = (value) => {
    return (
      selectedRows.filter((item) => item[columns[0]["keyField"]] === value)
        ?.length > 0
    );
  };

  return (
    <div>
      <Paper sx={paperStyles}>
        <TableContainer sx={tableHeight}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns?.map((column, index) => (
                  <TableCell
                    key={column.label + "_" + index}
                    align={column["align"]}
                    style={{
                      backgroundColor: thBackgoundColor,
                      color: thFontColor,
                      fontWeight: thFontWeight,
                      padding: "8px 0px 8px 8px",
                      width: column["width"] ? column["width"] : "maxContent",
                    }}
                  >
                    {column.label !== "" && <>{column.label}</>}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row, idx) => {
                return (
                  <TableRow
                    sx={{ lineHeight: "10px", padding: "0px" }}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={"row_" + idx}
                  >
                    {columns.map((col, colIdx) => {
                      const value = row[col["dataField"]];
                      return (
                        <TableCell
                          sx={{
                            lineHeight: "10x",
                            padding: "0px 0px 0px 8px",
                          }}
                          key={"cols_" + colIdx + "_" + row[col["keyField"]]}
                          align={col["align"]}
                        >
                          {col["fieldType"] === "number" &&
                            col["label"] === "" && (
                              <Checkbox
                                sx={{ p: 0 }}
                                checked={isRowSelected(row[col["keyField"]])}
                                onChange={() => handleRowSelect(row)}
                              />
                            )}
                          {col["fieldType"] === "date" && (
                            <>{utils.convertStringIntoUSDate(value)}</>
                          )}
                          {col["fieldType"] === "label" && <>{value}</>}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};
